export const useMicrosoft = () => {
  const userCentrics = useUserCentrics()

  const isLoaded = () => document.getElementById('MicrosoftAdvertisingScript') != null
  const isAllowedToLoad = computed(() => userCentrics.selectedPublishers.value.find(p => p.name === 'Microsoft Advertising'))

  const init = async () => {
    window.uetq = window.uetq || []
    window.uetq.push('consent', 'default', {
      ad_storage: 'denied',
    })
    if (isAllowedToLoad.value) {
      if (!isLoaded())
        return import('./microsoft').then(async ({ initMicrosoft }) => await initMicrosoft())
      else
        return Promise.resolve()
    }
  }

  const consentModeEvent = () => {
    if (isAllowedToLoad.value && isLoaded())
      window.uetq.push('consent', 'update', {
        ad_storage: 'granted',
      })
  }

  return { init, consentModeEvent }
}
